export default "__VITE_ASSET__6g3yp2zB__"